export default "/images/ico-h-notification.svg?1ed821eafbe42eb82c4a1e002d4d1afa";